import { htmlSafe } from '@ember/template';
import { SafeString } from 'handlebars';
import { helper } from '@ember/component/helper';
import escapeRegExp from 'lodash-es/escapeRegExp';

export function highlightSubstr([text, termToHighlight]: [string, string]):
  | SafeString
  | string {
  if (text) {
    return htmlSafe(
      text.replace(new RegExp(escapeRegExp(termToHighlight), 'i'), '<b>$&</b>'),
    );
  }

  return text;
}

export default helper(highlightSubstr);
